export default {
    emits: ['mouseenter', 'mouseleave', 'checked'],
    props: ['showCheckbox'],
    data: function() {
        return {
            checkValue: false
        };
    },
    methods: {
        onMouseEnter() {
            if (!this.checkValue) {
                this.$emit('mouseenter');
            }
        },
        onMouseLeave() {
            if (!this.checkValue) {
                this.$emit('mouseleave');
            }
        },
        onChecked() {
            if (this.checkValue) {
                this.$emit('checked');
            }
        }
    }
};
